import React, {Component, Fragment} from 'react';
import {inject, observer} from 'mobx-react';
import {FormattedMessage, injectIntl} from 'react-intl';
import {action, observable, runInAction} from 'mobx';
import Close from 'react-icons/lib/io/close';
import Slide from '@material-ui/core/Slide';
import DialogWrapper from '../../../components/dialog/Dialog';
import FormInput from '../../../components/FormHelpers/formField';
import MediaSelector from '../../../components/mediaSelector';
import {actions, category, DeviceType, events, LessonState, PlatformMode, ProjectType} from '../../../constants/enums';
import {isMobile} from '../../../utils/screenUtility';
import {isAdmin, isSchoolAdmin, isStudent, isTeacher} from '../../../utils/userUtility';
import {go} from '../../../utils/navigationUtility';
import BaseButton from '../../../components/button/BaseButton';
import {customEvent} from "../../../utils/analyticsUtil";
import './setProjectName.scss';

@injectIntl
@inject('dialogStore', 'projectStore', 'looperStore', 'appStore', 'mainStore')
@observer
class SetProjectNameDialog extends Component {
    @observable isSaveProcessing = false;

    @action save = async () => {
        const {projectStore, looperStore, appStore} = this.props;
        const {editedLesson, closeLessonNameDialog} = projectStore;
        this.isSaveProcessing = true;
        if (!isStudent()) {
            editedLesson.type = isTeacher() || isSchoolAdmin() ? ProjectType.Lesson : ProjectType.Global;
        }

        customEvent(events.CustomEvent, {category: category.Lesson, action: actions.CreateNewLesson});

        try {
            await looperStore.addProjectToLooper({...editedLesson, name: editedLesson.name});
            if (isAdmin()) {
                projectStore.handleProjectSave();
            }
            closeLessonNameDialog();
            go('/create', {}, true)
        } catch (err) {
            appStore.createAlertFromMessageId('error', 'notifications.saveError');
        } finally {
            projectStore.updateLessonState(LessonState.Update);
            runInAction(() => {
                this.isSaveProcessing = false;
            });
        }
    };

    onCancel = () => {
        // const {projectStore, looperStore} = this.props;
        // if (!projectStore.isNewLessonFromLooper) {
        //     go(`${isTeacher() ? `/library/${isEmpty(looperStore.loopedProject.assignedUsers) ? 'drafts' : 'lessons'}` : '/'}`);
        // }
        this.props.mainStore.updatePlatformMode(PlatformMode.Home);
        this.props.projectStore.closeLessonNameDialog();
    };

    onKeyUp = (e) => {
        if (e.which === 27) {
            this.onCancel();
            return;
        }
        const {name} = this.props.projectStore.editedLesson;
        if (e.which === 13 && name) this.save();
    };

    render() {
        const {dialogStore, projectStore, intl: {formatMessage: translate}} = this.props;
        const {showSetProjectNameDialog, closeSetProjectNameDialog} = dialogStore;
        const {editedLesson, editProjectName} = projectStore;
        const name = editedLesson ? editedLesson.name : '';
        const studentName = editedLesson && editedLesson.owner ? editedLesson.owner.name : '';
        const dialogProps = {
            ...(isMobile() && {TransitionComponent: Slide}),
            TransitionProps: {direction: 'up'},
            classes: {root: 'lesson-modal-root', paper: 'paper'},
            open: showSetProjectNameDialog
        };
        const localeKey = isStudent() ? 'project' : (editedLesson && editedLesson.parentOwnerId ? 'assignment' : 'lesson');

        return (
            <DialogWrapper {...dialogProps}>
                <div className="change-project-name">
                    <button className="change-project-name-close" onClick={closeSetProjectNameDialog}>
                        <Close />
                    </button>
                    <MediaSelector devices={[DeviceType.Desktop, DeviceType.Tablet]}>
                        <h2 className="change-project-name-heading">
                            {isStudent() && <FormattedMessage id="looper.nameForm.projectPlaceholder"/>}
                            {(isTeacher() || isSchoolAdmin()) && <FormattedMessage id="assignments.createModal.title"/>}
                        </h2>
                    </MediaSelector>
                    <MediaSelector devices={[DeviceType.Mobile]}>
                        <div className="modal-page-name">
                            {studentName
                                ? <Fragment>{studentName}</Fragment>
                                : <FormattedMessage id={isStudent() ? 'jams.title' : 'header.myLessons'}/>
                            }
                        </div>
                        <h2 className="change-project-name-heading">
                            <FormattedMessage id={`looper.nameForm.${localeKey}MobileTitle`}/>
                        </h2>
                        <p className="change-project-name-description">
                            <FormattedMessage id={`looper.nameForm.${localeKey}Description`}/>
                        </p>
                    </MediaSelector>
                    <FormInput
                        type='text'
                        name='name'
                        inputPlaceholder={translate({id: `looper.nameForm.${localeKey}Placeholder`})}
                        onChange={editProjectName}
                        onKeyUp={this.onKeyUp}
                        value={name}/>
                    <div className="change-project-name-actions">
                        <MediaSelector devices={[DeviceType.Desktop, DeviceType.Tablet]}>
                            <BaseButton
                                disabled={this.isSaveProcessing}
                                className="change-project-name-btn cancel"
                                label={translate({id: 'general.cancel'})}
                                type="button"
                                onClick={this.onCancel} />
                        </MediaSelector>
                        <BaseButton
                            disabled={!name || this.isSaveProcessing}
                            className="change-project-name-btn save"
                            label={translate({id: 'createLesson.create'})}
                            type="button"
                            onClick={this.save} />
                    </div>
                </div>
            </DialogWrapper>
        );
    }
}

export default SetProjectNameDialog;
